import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronDown, Lock } from 'lucide-react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '../ui/dropdown-menu';

/**
 * Dark-luxury dropdown trigger for a single nav group (Trade / Learn / Club).
 * Highlights when the current pathname is one of its child routes.
 */
const NavGroupMenu = ({ group, pathname, isAuthed, isPro }) => {
  const isActive = group.items.some((i) => pathname === i.path);

  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        className={`flex items-center gap-1 text-sm font-medium px-2 py-1.5 rounded-md transition-colors outline-none ${
          isActive
            ? 'text-cyan-300'
            : 'text-white/70 hover:text-white'
        }`}
        data-testid={`nav-group-${group.label.toLowerCase()}`}
      >
        {group.label}
        <ChevronDown className="w-3.5 h-3.5 opacity-60" />
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align="start"
        sideOffset={10}
        className="w-72 bg-[#0a0a14] border border-white/10 text-white shadow-[0_25px_60px_-20px_rgba(99,102,241,0.45)]"
      >
        {group.items.map((item) => {
          const authLocked = item.requiresAuth && !isAuthed;
          const proLocked = item.requiresPro && !isPro;
          const locked = authLocked || proLocked;
          return (
            <DropdownMenuItem
              key={item.path}
              asChild
              className="focus:bg-white/5 cursor-pointer rounded-md px-2 py-2"
            >
              <Link
                to={item.path}
                className="block"
                data-testid={`nav-${item.name.toLowerCase().replace(/\s+/g, '-')}`}
              >
                <div className="flex items-center justify-between gap-2">
                  <span className={`text-sm font-medium ${pathname === item.path ? 'text-cyan-300' : 'text-white'}`}>
                    {item.name}
                  </span>
                  <div className="flex items-center gap-1.5">
                    {item.highlight && (
                      <span className="text-[9px] uppercase tracking-wider px-1.5 py-0.5 rounded bg-cyan-400/20 text-cyan-300 border border-cyan-400/30">
                        New
                      </span>
                    )}
                    {proLocked && (
                      <span className="text-[9px] uppercase tracking-wider px-1.5 py-0.5 rounded bg-violet-500/20 text-violet-300 border border-violet-400/30">
                        Pro
                      </span>
                    )}
                    {locked && <Lock className="w-3 h-3 text-white/40" />}
                  </div>
                </div>
                {item.desc && (
                  <p className="text-[11px] text-white/50 leading-snug mt-0.5">
                    {item.desc}
                  </p>
                )}
              </Link>
            </DropdownMenuItem>
          );
        })}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default NavGroupMenu;
